import React, { useEffect, useMemo, useState } from "react"
import MetaTags from "react-meta-tags"
import toastr from "toastr"
import { Col, Container, Row } from "reactstrap"
import { isEmpty } from "lodash"

//redux
import { useSelector, useDispatch } from "react-redux"
import { getSpecialDates, clearMessage } from "../../store/specialdates/actions"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import SpecialDateList from "./SpecialDateList"
import Spinner from "components/Common/Spinner"
import { messageTitle } from "constants/common"

const SpecialDates = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const { specialDates, isSpecialDateDeleted, message, error, file } =
    useSelector(state => ({
      specialDates: state.SpecialDates.specialDates,
      isSpecialDateDeleted: state.SpecialDates.isSpecialDateDeleted,
      message: state.SpecialDates.message,
      error: state.SpecialDates.specialDatesError,
      file: state.SpecialDates.file,
    }))

  useEffect(() => {
    dispatch(getSpecialDates())
  }, [dispatch])

  useMemo(() => {
    setLoading(false)
    if (message) {
      message == "PDF file content not found." ||
      message == "Failed to export invalid file type."
        ? toastr.error(message, messageTitle)
        : toastr.success(message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      setLoading(false)
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  return (
    <React.Fragment>
      <Spinner loading={loading} />
      <div className="page-content">
        <MetaTags>
          <title>Manage Special Dates | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Admins" breadcrumbItem="Manage Special Dates" />
          <Row>
            <Col lg="12">
              <SpecialDateList
                getSpecialDates={getSpecialDates}
                isSpecialDateDeleted={isSpecialDateDeleted}
                specialDates={specialDates}
                setLoading={setLoading}
                file={file}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SpecialDates
